import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  click() {
    window.fbq &&
      window.fbq(
        'track',
        'Lead',
        {
          content_category: 'broadband',
          content_name: 'broadband'
        },
        { event_id: window.fbEventId }
      )
  }
}
